import React, { useEffect } from 'react';
import { whoami } from '@/api/auth.ts';
import { useWhoamiStore } from '@/store/useWhoamiStore.ts';
import { redirectToBackendAuthTarget } from '@/utils/authRedirect.ts';

const WhoamiProvider: React.FC = () => {
	const setWhoami = useWhoamiStore(state => state.setWhoami);

	useEffect(() => {
		whoami().then(data => {
			if (redirectToBackendAuthTarget(data.redirectUrl)) {
				return;
			}

			setWhoami(data);
		});
	}, [setWhoami]);

	return null;
};

export default WhoamiProvider;
